// LEGACY CODE
export var options = {
  width: '100%',
  search_contains: true
};
/*
 * Chosen Select Boxes
 */

export function applyToSelectBoxes() {
  var select_boxes = $('.for_chosen').not('.filter select');
  var add_filter_select = $('#add_filter');

  if (add_filter_select.length && add_filter_select.hasClass('for_chosen')) {
    $('#add_filter').chosen(options);
  }
  /**
   * Adding width option is a fix for 'for_chosen' since when there are
   * hidden fields their width is 0px when they are visible
   * more info here: https://github.com/harvesthq/chosen/issues/92
   */


  $.map(select_boxes, function (box) {
    $(box).chosen(options);
  });
}
export function applyToSelectBoxesWithContentSearch() {
  var select_boxes = $('.for_chosen_with_content_search');
  $.map(select_boxes, function (box) {
    $(box).chosen(options);
  });
}